/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1SerievideoIdMutationRequest,
  PutApiV1SerievideoIdMutationResponse,
  PutApiV1SerievideoIdPathParams,
  PutApiV1SerievideoIdQueryParams,
  PutApiV1SerievideoId400,
  PutApiV1SerievideoId401,
  PutApiV1SerievideoId404,
  PutApiV1SerievideoId500,
} from "../../types/serieVideoRegistroController/PutApiV1SerievideoId.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPutApiV1SerievideoIdUrl(id: PutApiV1SerievideoIdPathParams["id"]) {
  const res = { method: "PUT", url: `/api/v1/serievideo/${id}` as const };
  return res;
}

/**
 * @description Atualiza um vídeo (multipart/form-data). Atualiza título/resumo/embed no idioma corrente e permite substituir ou remover a imagem de capa. **(Requer Authorization para autenticação)**
 * @summary Atualizar vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:id}
 */
export async function putApiV1SerievideoId(
  id: PutApiV1SerievideoIdPathParams["id"],
  data?: PutApiV1SerievideoIdMutationRequest,
  params?: PutApiV1SerievideoIdQueryParams,
  config: Partial<RequestConfig<PutApiV1SerievideoIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PutApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoId400
      | PutApiV1SerievideoId401
      | PutApiV1SerievideoId404
      | PutApiV1SerievideoId500
    >,
    PutApiV1SerievideoIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1SerievideoIdUrl(id).url.toString(),
    params,
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
